export default __webpack_public_path__ + "static/media/a4.31bab210.png";